module.exports = __webpack_public_path__ + "static/media/delete_audio.2a7fa80a.svg";